import { CloudinaryAdvancedImage } from '../Misc/CloudinaryImage'
import React from 'react'
import styled from '@emotion/styled'
import { FullWidth } from '../Misc/FullWidth'

export const ImageBlockPublic = ({
  cloudinaryFileId,
  backgroundColor,
  cloudName,
}: {
  cloudinaryFileId?: string
  backgroundColor?: string
  cloudName?: string
}): JSX.Element | null => {
  if (cloudinaryFileId) {
    return (
      <FullWidth backgroundColor={backgroundColor}>
        <ImageWrapper>
          <CloudinaryAdvancedImage
            imagePublicId={cloudinaryFileId}
            cloudName={cloudName}
            style={{
              maxWidth: 'min(672px, 100vw - 48px)',
              maxHeight: '500px',
              borderRadius: '4px',
              width: 'auto',
            }}
            imageAltText=''
          />
        </ImageWrapper>
      </FullWidth>
    )
  }

  return null
}

const ImageWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  @media print {
    img {
      max-width: 744px !important;
    }
  }
`
